/**
 * Shared Nomad pagination class hooks.
 * Visual skin lives in styles/nomad/ui.css (.ui-pagination-*).
 * Active page = outline; inactive = ghost (h-9, text-sm, radius-sm).
 */
export const PAGINATION_ROOT = 'ui-pagination flex flex-wrap items-center gap-1 text-sm'

export const PAGINATION_TOTAL = 'ui-pagination-total-text text-sm text-[var(--muted-foreground)]'

export const PAGINATION_ITEM = 'ui-pagination-item'

export const PAGINATION_ITEM_ACTIVE = 'ui-pagination-item-active'

export const PAGINATION_PREV = 'ui-pagination-prev'

export const PAGINATION_NEXT = 'ui-pagination-next'

export const PAGINATION_ELLIPSIS = 'ui-pagination-ellipsis'

export const PAGINATION_SELECT =
  'h-9 rounded-[var(--radius-sm)] border border-[var(--input)] bg-transparent px-3 text-sm text-[var(--foreground)] shadow-[var(--shadow-xs)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--field-ring)] focus-visible:ring-offset-2'
